import Component from '../Component';
import {flipPoints, toHumanTime} from '../Helpers';
import $ from '../../vendor/CustomJquery';
import find from 'lodash/find';
import pickBy from 'lodash/pickBy';
import startsWith from 'lodash/startsWith';
import endsWith from 'lodash/endsWith';
import Routes from '../../routes';
import Vue from 'vue';
import RouteList from './vue/RouteList.vue';
import RoutePlayer from './vue/RoutePlayer.vue';
import RouteMap from './vue/RouteMap.vue';
import RouteMapLegend from './vue/RouteMapLegend.vue';
import RoutePathSwitch from './vue/RoutePathSwitch.vue';

export default class Route extends Component {

  vm = null;

  configure() {
    return super.configure();
  }

  initialize() {
    this.form = $('.is-tour-form');
    this.start();
    return super.initialize();
  }

  start() {

    if (this.form.length === 0) {
      return false;
    }

    this.initVM();
  }

  subscribeToEvents() {
  }

  onClick(event) {
    event.preventDefault();
  }

  initVM() {

    let parent = this;

    this.vm = new Vue({
      el:       '#routeManager',
      template: '#routeManagerTemplate',
      components: {
        RouteList,
        RoutePlayer,
        RouteMap,
        RouteMapLegend,
        RoutePathSwitch
      },
      watch: {
        routeObjects: {
          handler: function () {
            this.rebuildRoutePaths();
          },
          immediate: true,
        },
        routePaths: {
          handler: function () {
            // this.$forceUpdate();
          },
          immediate: true,
        },
        updatedObjects: {
          handler: function () {
            // this.$forceUpdate();
          },
          immediate: true,
        },
      },
      data: {
        rand: Math.random(),
        app: this.App,
        sectorId: window.sectorId || 0,
        distance: 0,
        duration: 0,
        routePaths: {},
        originalRouteObjects: window.routeObjects || [],
        routeObjects: window.routeObjects || [],
        objects: [],
        updatedObjectsPositions: [],
        providers: [
          'custom',
          'mapbox',
          'google',
          'mapQuest',
          'bing',
          'skobbler',
          'default'
        ],
        playerState: {
          currentObjectId:    null,
          currentObjectIndex: null,
          currentProgress:    0, // 0 - 100%
          state:              'paused'
        }
      },
      computed: {
        statistics() {

          let distance = 0,
              duration = 0;

          for(let i = 0; i < this.routeObjects.length; i++) {

            let currentRouteObject = this.routeObjects[i];

            duration += currentRouteObject.audio_duration;

            if (i > 0 && (i - 1) <= this.routeObjects.length) {

              let previousRouteObject = this.routeObjects[i-1],
                  key = this.getRoutePathKey(previousRouteObject, currentRouteObject),
                  routePath = this.getRoutePath(key);

              if (typeof routePath === 'object' && routePath.isLoading === false) {
                distance += routePath.distance;
                duration += routePath.time;
              }

            }
          }

          let distanceFormatted = (distance / 1000).toFixed(1),
              durationFormatted = toHumanTime(duration, 'hh:mm');

          return {
            distance:          distance,
            distanceFormatted: distanceFormatted,
            duration:          duration,
            durationFormatted: durationFormatted,
            stopsCount:        this.routeObjects.length
          }
        }
      },
      created: function() {
        this.loadObjects();
        this.trackSectorChange();
      },
      updated: function () {
        // parent.logger('Updated:', arguments);
      },

      methods: {

        addRouteObject(id) {
          this.routeObjects.push(
            this.getObject(id)
          );
        },
        removeRouteObject(id) {
          this.$delete(this.routeObjects, this.getRouteObjectIndex(id));
        },
        toggleRouteObject(id) {

          if (this.getRouteObjectIndex(id) >= 0) {
            this.removeRouteObject(id);
          } else {
            this.addRouteObject(id);
          }

        },
        updateObjectPosition(id, position) {

          parent.logger(`Update object[${id}] position to:`, position);

          if (this.getObjectIndex(id) >= 0) {
            let object = this.getObject(id);
            object.position_point = {
              lat: position.lat,
              lng: position.lng,
            };
            this.$set(this.routeObjects, this.getRouteObjectIndex(id), object);
            this.$set(this.objects, this.getObjectIndex(id), object);
            this.deleteObjectRoutePaths(object.tnid);
            this.addUpdatedObjectPosition(object);
            // this.$forceUpdate();
          }
        },
        addUpdatedObjectPosition(object) {

          let index = this.updatedObjectsPositions.map(updatedObject => updatedObject.tnid).indexOf(object.tnid);
          if (index >= 0) {
            this.$set(this.updatedObjectsPositions, index, object);
          } else {
            this.updatedObjectsPositions.push(object);
          }
        },
        getRouteObjectIndex(id) {
          return this.routeObjects.map(object => object.id).indexOf(id);
        },
        reorder(value) {
          parent.logger('Reordered:', value);
          this.routeObjects = value;
          this.$forceUpdate();
        },
        loadObjects() {

          return parent.App.API.get(Routes.API.CONTENT.OBJECTS.LIST, {
            'filters[sector]': this.sectorId,
            per_page:          1000
          }).catch((error) => {
            parent.App.UI.Dialog.alert(
              parent.App.Language.get('errors.internal_error')
            );
          }).then((response) => {

            if (response.data) {
              if (typeof response.data.data === 'object') {
                let objects = (response.data.data || []);
                this.objects = [];
                this.objects.push(... objects);
                return this;
              }
            }

            return parent.App.UI.Dialog.alert(
              parent.App.Language.get('errors.internal_error')
            );
          });

        },
        getObjectIndex(id) {
          return this.objects.map(object => object.id).indexOf(id);
        },
        getObject(id) {
          return $.grep(this.objects, function(object) {
            return object.id === id;
          })[0];
        },

        getRoutePath(key) {
          return this.routePaths[key];
        },

        getRoutePathKey(previousRouteObject, currentRouteObject) {
          if (typeof previousRouteObject === 'object' && typeof currentRouteObject === 'object') {
            return `${previousRouteObject.tnid}-${currentRouteObject.tnid}`;
          }
          return `${previousRouteObject}-${currentRouteObject}`;
        },

        getRoutePathInEditMode() {
          return find(this.routePaths, ['isInEditMode', true]) || null;
        },

        isAnyRoutePathInEditMode() {
          return typeof find(this.routePaths, ['isInEditMode', true]) !== 'undefined';
        },

        openRoutePath(key) {

          this.closeAllRoutePaths();

          let routePath = this.getRoutePath(key);
          if (typeof routePath !== 'undefined') {
            routePath.isOpened = true;

            this.updateRoutePath(
              key,
              routePath
            );
          }
        },

        closeRoutePath(key) {
          let routePath = this.getRoutePath(key);

          if (typeof routePath !== 'undefined') {
            routePath.isOpened = false;

            this.updateRoutePath(
              key,
              routePath
            );
          }
        },

        closeAllRoutePaths() {
          let updatedRoutePaths = {};

          for (let key in this.routePaths) {
            if (this.routePaths.hasOwnProperty(key)) {
              let routePath = this.getRoutePath(key);
              if (typeof routePath !== 'undefined') {
                routePath.isOpened = false;
                updatedRoutePaths[key] = routePath;
              }
            }
          }

          this.updateRoutePaths(updatedRoutePaths);
        },

        switchRoutePathToProvider(key, provider) {
          let routePath = this.getRoutePath(key);

          if (this.isAnyRoutePathInEditMode() && provider !== 'custom') {
            this.exitRoutePathEditMode(
              this.getRoutePathInEditMode().key
            );
          }

          let defaultCustomRoute = {
            time:     0,
            distance: 0,
            points:  [
              routePath.from.coordinates,
              routePath.to.coordinates
            ]
          };

          let route = this.getRoutePathProviderRoute(
            routePath,
            provider
          );

          parent.logger(`Switch route ${key} to [${provider}] route:`, route);

          if (
            (typeof route !== 'undefined')
            || (typeof route == 'undefined' && provider === 'custom')
          ) {

            if (typeof route == 'undefined') {
              route = defaultCustomRoute;
            }

            // Для найденного маршрута устанавливаем показатели,
            // Если маршрут ручной (provider === 'custom')
            // и его не существует, то проставляем нули и рисуем прямую
            routePath.provider = provider;
            routePath.time = route.time || 0;
            routePath.distance = route.distance || 0;
            routePath.points = route.points; // || [routePath.from.coordinates, routePath.to.coordinates];

            // Обновим профиль
            this.updateRoutePath(
              key,
              routePath
            );

          } else {
            // TODO: error
          }
        },

        getRoutePathProviderRoute(routePath, provider) {
          return find(routePath.providersRoutes, ['provider', provider]);
        },

        enterRoutePathToEditMode(key) {
          this.switchRoutePathToProvider(key, 'custom');

          let routePath = this.getRoutePath(key);

          parent.logger(`Switch route ${key} to edit mode`);

          routePath.isInEditMode = true;

          // Обновим профиль
          this.updateRoutePath(
            key,
            routePath
          );

        },
        exitRoutePathEditMode(key) {

          let routePath = this.getRoutePath(key);

          parent.logger(`Exit route ${key} from edit mode`);

          routePath.isInEditMode = false;

          // Обновим профиль
          this.updateRoutePath(
            key,
            routePath
          );

        },

        saveRoutePathProviderRoute(key) {

          let routePath = this.getRoutePath(key),
              providerRoute = this.getRoutePathProviderRoute(routePath, routePath.provider);

          routePath.isLoading = true;
          this.updateRoutePath(key, routePath);

          let profile = {
            id:               routePath.id,
            from:             routePath.from,
            to:               routePath.to,
            distance:         routePath.distance,
            time:             routePath.time,
            points:           routePath.points,
            provider:         routePath.provider,
            providers_routes: routePath.providersRoutes
          };

          return parent.App.API.post(
            Routes.API.CONTENT.GEO.ROUTE.UPDATE,
            profile
          ).catch((error) => {
            return parent.App.UI.Dialog.alert(
              parent.App.Language.get('errors.internal_error')
            );
          }).then((response) => {

            if (response.data) {
              if (typeof response.data === 'object') {
                this.closeRoutePath(key);
                return this.processRoutePaths(response.data.data);
              }
            }

            return parent.App.UI.Dialog.alert(
              parent.App.Language.get('errors.internal_error')
            );
          });

        },

        revertRoutePathToOriginal(key) {

          if (this.isAnyRoutePathInEditMode()) {
            this.exitRoutePathEditMode(
              this.getRoutePathInEditMode().key
            );
          }

          let routePath = this.getRoutePath(key),
              providerRoute = this.getRoutePathProviderRoute(routePath, routePath.originalProvider);

          routePath.points = routePath.originalPoints;
          routePath.provider = routePath.originalProvider;

          // Set original time and distance
          routePath.time = providerRoute.time;
          routePath.distance = providerRoute.distance;

          this.updateRoutePath(key, routePath);
          this.closeRoutePath(key);
        },

        updateRoutePath(key, routePath) {

          let updatedRoutePaths = {};
          updatedRoutePaths[key] = routePath;

          parent.logger(`Update route path[${key}]:`, JSON.parse(JSON.stringify(routePath)));

          this.updateRoutePaths(updatedRoutePaths);
        },
        updateRoutePaths(routePaths) {
          this.routePaths = Object.assign(
            {},
            this.routePaths,
            routePaths
          );
        },
        deleteObjectRoutePaths(id) {
          this.routePaths = pickBy(this.routePaths,(value, key) => {
            return !startsWith(key, `${id}-`) && !endsWith(key, `-${id}`);
          });
        },
        rebuildRoutePaths() {

          let paths = {},
              routePathsToRequest = [];

          for(let i = 0; i < this.routeObjects.length; i++) {
            // Create path
            if (i > 0 && (i - 1) <= this.routeObjects.length) {

              let currentRouteObject = this.routeObjects[i],
                previousRouteObject = this.routeObjects[i-1],
                key = this.getRoutePathKey(previousRouteObject, currentRouteObject);

              // Check for cache route path
              if (typeof this.routePaths[key] === 'object') {
                paths[key] = this.routePaths[key];
              } else {

                // New route path
                paths[key] = {
                  id:        0,
                  key:       key,
                  type:      'path',
                  from:      {
                    place_id: previousRouteObject.tnid,
                    lat:       previousRouteObject.position_point.lat,
                    lng:       previousRouteObject.position_point.lng,
                    coordinates: [
                      previousRouteObject.position_point.lng,
                      previousRouteObject.position_point.lat
                    ]
                  },
                  to:        {
                    place_id: currentRouteObject.tnid,
                    lat:       currentRouteObject.position_point.lat,
                    lng:       currentRouteObject.position_point.lng,
                    coordinates: [
                      currentRouteObject.position_point.lng,
                      currentRouteObject.position_point.lat
                    ]
                  },
                  points:    [
                    [previousRouteObject.position_point.lng, previousRouteObject.position_point.lat],
                    [currentRouteObject.position_point.lng, currentRouteObject.position_point.lat],
                  ],
                  isLoading: true,
                  isOpened:  false,
                  isInEditMode: false,
                  provider:  null,
                };

                routePathsToRequest.push({
                  from: previousRouteObject,
                  to:   currentRouteObject
                });

              }

            }
          }

          parent.logger('Route paths rebuilt:', paths);
          parent.logger('Route paths to request:', routePathsToRequest);

          this.routePaths = paths;
          // this.routePaths = [];
          // this.routePaths.push(... paths);
          this.requestRoutePaths(routePathsToRequest);

        },

        requestRoutePaths(routePaths) {
          let data = this.buildRoutePathsRequestData(routePaths);

          if (data.length === 0) {
            return this;
          }

          parent.logger('Request route paths with data:', data);

          return parent.App.API.post(
            Routes.API.CONTENT.GEO.ROUTE.SEARCH,
            {
              route: data
            }
          ).catch((error) => {
            parent.App.UI.Dialog.alert(
              parent.App.Language.get('errors.internal_error')
            );
          }).then((response) => {

            if (response.data) {
              if (typeof response.data.data === 'object') {
                return this.processRoutePaths(response.data.data || []);
              }
            }

            return parent.App.UI.Dialog.alert(
              parent.App.Language.get('errors.internal_error')
            );
          });

        },

        buildRoutePathsRequestData(paths) {
          let data = [];

          paths.forEach((path, index) => {

            data.push({
              from: {
                place_id: path.from.tnid,
                lat:       path.from.position_point.lat,
                lng:       path.from.position_point.lng,
              },
              to: {
                place_id: path.to.tnid,
                lat:       path.to.position_point.lat,
                lng:       path.to.position_point.lng,
              }

            });
          });

          return data;
        },

        /**
         * Process route paths
         *
         * @param routePaths
         */
        processRoutePaths(routePaths) {

          parent.logger('Process route paths:', routePaths);

          let updatedRoutePaths = {};

          routePaths.forEach((routePath, index) => {
            let key = this.getRoutePathKey(
              routePath.from.place_id,
              routePath.to.place_id
            );

            let cachedRoutePath = this.getRoutePath(key);

            if (typeof cachedRoutePath !== 'undefined') {

              updatedRoutePaths[ key ] = Object.assign({}, cachedRoutePath, {
                id: routePath.id,
                isInEditMode: false,
                isLoading: false,
                distance: routePath.distance,
                time: routePath.time,
                points: routePath.points,
                originalPoints: routePath.points,
                provider: routePath.provider,
                originalProvider: routePath.provider,
                providersRoutes: routePath.providers_routes || [],
              });

            } else {
              parent.logger('No cached route path found:', key);
            }

            this.updateRoutePaths(updatedRoutePaths);

          });
        },
        transformRequestedRoutePath(routePath) {

          routePath.points = flipPoints(routePath.points);

          if (typeof routePath.providers_routes !== 'undefined') {
            routePath.providers_routes = routePath.providers_routes.forEach((providerRoute) => {
              providerRoute.points = flipPoints(providerRoute.points);
              return providerRoute;
            });
          }

          return routePath;
        },
        trackSectorChange() {
          parent.App.Events.subscribe('sector_id.change', (id) => {
            parent.logger('sector id changed');
            this.sectorId = parseInt(id);
            this.loadObjects();
          });
        },
        updatePlayerState(data) {
          this.playerState = data;
        }

      }

    }).$on('addObjectInRoute', function (id) {
      this.addRouteObject(id);
    }).$on('removeObjectFromRoute', function (id) {
      this.removeRouteObject(id);
    }).$on('toggleRouteObject', function (id) {
      this.toggleRouteObject(id);
    }).$on('updateObjectPosition', function (id, position) {
      this.updateObjectPosition(id, position);
    }).$on('reorder', function (value) {
      this.reorder(value);
    }).$on('updatePlayerState', function (value) {
      parent.logger('Update player state with data:', value);
      this.updatePlayerState(value);
    });

  }

}